import { Component } from '@angular/core';

@Component({
  selector: 'gmo-all-activity',
  imports: [],
  templateUrl: './all-activity.html',
  styleUrl: './all-activity.scss',
})
export class AllActivity {

}
